import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { CookieService } from 'ngx-cookie-service';
import { MenuItem, MessageService } from 'primeng/api';
import { EMPTY, from } from 'rxjs';
import { catchError, concatMap, finalize, reduce, tap } from 'rxjs/operators';
import { AccountManagementService } from 'src/app/services/account-management.service';
import { BranchManagementService } from 'src/app/services/branch-management.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { StateService } from 'src/app/services/state.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import * as XLSX from 'xlsx';
import { read, utils } from 'xlsx';
import * as bootstrap from 'bootstrap';
import DOMPurify from 'dompurify';
import { PdfValidationService } from 'src/app/services/pdf-validation.service';
import { PdfSecurityService } from 'src/app/services/pdfsecurity.service';
import { CAT_EXECUTION_UPLOAD_CONSTANTS } from 'src/app/models/cat-execution-upload.constant';


@Component({
    selector: 'app-bulk-upload-form',
    templateUrl: './bulk-upload-form.component.html',
    styleUrls: ['./bulk-upload-form.component.scss'],
    standalone: false
})
export class BulkUploadFormComponent implements OnInit {
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  branchData: any = [];
  selectedBranch: any;
  showUploadDocuments: boolean = true;
  showEstampDetails: boolean = false;
  showEsignDetails: boolean = false;
  showConfirmation: boolean = false;

  //-------------------------Step Active --------------------------------------//
  active_product: boolean = false;
  active_eStamp: boolean = false;
  active_eSign: boolean = false;
  active_confirm: boolean = false;
  //-------------------Import & export variables ----------------------------//
  uploadDocumentsData: any;
  editTemplateData: any;
  estampData: any;
  esignData: any = { toBeEsigned: true };
  orderConfirmationData: any = { service: 'CAT-Edit' };
  uploadId!: string;
  displaybread: string;
  itemsEstamp!: MenuItem[];
  itemsCatUpload!: MenuItem[];
  itemsCatEdit!: MenuItem[];
  itemsEsign!: MenuItem[];
  selectedFile: any;
  headerData: any = [];
  fileUrl: string;
  fileName: string;
  onlyEstamp: boolean = false;
  onlyEsign: boolean = false;
  userRole: string;
  isCatImport: boolean;
  showFileName: boolean;
  uploadFiles: File[] = [];
  tempFiles: File[] = [];
  chooseFile: any;
  bulkOrderDetailsForm: FormGroup;
  noBranch: boolean = false;
  showHdfcFields: boolean = true;
  organisationId: string;
  enableRefIdField: boolean;
  submitted: boolean = false;
  accountUserData: any = [];
  defaultAccountId: string;
  selectedAccount: any;
  stateData: any;
  selectedValue: any;
  previousSelection: any[] = [];
  selectedBranches: any[] = [];
  userId: any;
  userBranches: any;

  isDragging: boolean = false;
  fileSizeError: boolean;

  // Cloud import Declarations
  showGoogleDriveModal = false;
  showDropboxModal = false;
  previewModalVisible: boolean = false;
  previewFile: File | null = null;
  previewFileName: string = '';
  activePreviewIndex: number = -1;
  previewModalMode: 'upload' | 'preview' = 'preview';
  newlyUploadedIndices: number[] = [];

  previewUploadedFile(index: number) {
    if (this.uploadFiles && this.uploadFiles[index]) {
      this.newlyUploadedIndices = [];
      this.previewModalMode = 'preview';
      this.activePreviewIndex = index;
      this.previewFile = this.uploadFiles[index];
      this.previewFileName = this.uploadFiles[index].name;
      this.previewModalVisible = true;
    }
  }

  triggerNewlyUploadedPreview(startIndex: number, count: number) {
    if (startIndex < 0 || startIndex >= this.uploadFiles.length) return;

    this.newlyUploadedIndices = [];
    for (let i = startIndex; i < startIndex + count; i++) {
      this.newlyUploadedIndices.push(i);
    }

    this.activePreviewIndex = startIndex;
    this.previewFile = this.uploadFiles[startIndex];
    this.previewFileName = this.uploadFiles[startIndex].name;
    this.previewModalMode = 'upload';
    this.previewModalVisible = true;
  }

  onPreviewUploadConfirmed(event: { file: File }) {
    if (this.activePreviewIndex !== -1 && this.uploadFiles[this.activePreviewIndex]) {
      this.uploadFiles[this.activePreviewIndex] = event.file;
      this.previewFile = event.file;
      this.previewFileName = event.file.name;
      const formArray = this.bulkOrderDetailsForm.get('orders') as FormArray;
      if (formArray && formArray.at(this.activePreviewIndex)) {
        formArray.at(this.activePreviewIndex).patchValue({
          file_name: event.file.name,
        });
      }
    }
    this.newlyUploadedIndices = [];
    this.previewModalMode = 'preview';
    this.messageService.add({
      severity: 'success',
      summary: 'Upload Confirmed',
      detail: `${event.file.name} uploaded successfully`,
    });
    this.cdr.detectChanges();
  }

  onPreviewUploadCancelled() {
    if (this.previewModalMode === 'upload' && this.newlyUploadedIndices && this.newlyUploadedIndices.length > 0) {
      const indicesToRemove = [...this.newlyUploadedIndices].sort((a, b) => b - a);
      for (const idx of indicesToRemove) {
        this.removeFileName(idx);
      }
      this.messageService.add({
        severity: 'info',
        summary: 'Upload Cancelled',
        detail: 'Document upload was cancelled and removed.',
      });
    }
    this.newlyUploadedIndices = [];
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  onPreviewFileSaved(event: { file: File }) {
    let idx = this.activePreviewIndex;
    if (idx < 0 || idx >= this.uploadFiles.length) {
      idx = this.uploadFiles.findIndex((f) => f.name === event.file.name);
    }
    if (idx !== -1 && this.uploadFiles[idx]) {
      this.uploadFiles[idx] = event.file;
      this.previewFile = event.file;
      this.previewFileName = event.file.name;
    }
  }
  showOneDriveModal = false;
  visible: boolean = false;
  showLinkModal: boolean = false;
  pdfUrl = '';
  downloadingFromUrl = false;
  signatureError: boolean = false;
  safePreviewContent: string = '';
  securityError: boolean = false;
  currentStampType: string = '';

  base64Data: string;
  get dropboxEnabled(): boolean {
    return this.storageService?.getDropBoxEnabled() || false;
  }
  referenceIdValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const validPattern = /^[a-zA-Z0-9_-]*$/;
      return validPattern.test(value) ? null : { invalidChars: true };
    };
  }
  //------------------------------------------------------------------------------//
  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private modalService: NgbModal,
    private _location: Location,
    private http: HttpClient,
    private catUploadService: CatUploadService,
    private messageService: MessageService,
    private accountManagementService: AccountManagementService,
    private branchManagementService: BranchManagementService,
    private userManagementService: UserManagementService,
    private pdfValidationService: PdfValidationService,
    private pdfSecurityService: PdfSecurityService,
    private cdr: ChangeDetectorRef,
  ) {
    this.userRole = this.storageService.getRole() || null;
    this.defaultAccountId = this.storageService.getAccountId() || null;
    this.activatedRouter.params.subscribe((params) => {
      this.uploadId = params['id'];
    });

    if (this._location.path() == '/doqfy/bulk-upload/form/cat-edit') {
      this.uploadId = 'Cat-Edit';
    } else if (this._location.path() == '/doqfy/bulk-upload/form/cat-upload') {
      this.uploadId = 'Cat-Upload';
      this.displaybread = ' Contract Execution Orders';
    } else if (this._location.path() == '/doqfy/bulk-upload/form/e-stamp') {
      this.displaybread = this.uploadId = 'E-Stamp';
    } else if (this._location.path() == '/doqfy/bulk-upload/form/e-sign') {
      this.displaybread = this.uploadId = 'E-Sign';
    } else if (this._location.path() == '/doqfy/bulk-upload/form/cat-import') {
      this.isCatImport = true;
      this.displaybread = this.uploadId = 'Cat-Import';
    }
    this.organisationId = this.storageService.getOrganization() || '';
    this.showHdfcFields = this.organisationId === 'HDHO';
    this.selectedValue = this.storageService.getBranch() || null;
    this.userId = this.storageService.getUserID() || null;
    if (this.userId) {
      this.getUserDetails(this.userId);
    }
  }

  ngOnInit(): void {
    this.itemsCatUpload = [
      {
        label: 'Both(Estamp & Esign)',
        icon: 'pi pi-info',
        command: () => {
          this.downloadSample('Cat-Upload');
        },
      },
      {
        label: 'EStamping',
        icon: 'pi pi-info',
        command: () => {
          this.downloadSample('E-Stamps');
        },
      },
      {
        label: 'ESigning',
        icon: 'pi pi-info',
        command: () => {
          this.downloadSample('E-Sign');
        },
      },
    ];
    this.selectedBranch = this.storageService.getBranch() || '';

    // Then get account data and initialize form
    this.accountManagementService.getAccountPerUser().subscribe({
      next: (res: any) => {
        this.accountUserData = res.content;
        this.initForm();
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to load account data',
        });
      },
    });
    this.getRefIdConsent();
    this.storageService.selectedStampProcessType$.subscribe(type => {
      this.currentStampType = type;
      this.cdr.detectChanges();
    });
  }
  initForm() {
    this.bulkOrderDetailsForm = this.formBuilder.group({
      orders: this.formBuilder.array([]),
    });

    if (this.uploadFiles && this.uploadFiles.length > 0) {
      console.log('Number of files:', this.uploadFiles.length);

      // Create a form group for each file
      this.uploadFiles.forEach((_, index) => {
        const orderGroup = this.createOrderGroup(index);
        (this.bulkOrderDetailsForm.get('orders') as FormArray).push(orderGroup);
      });
    }
  }
  get orders() {
    return this.bulkOrderDetailsForm.get('orders') as FormArray;
  }

  goToDocumentList(): void {
    this.router.navigate(['/doqfy/bulk-upload/contract-import-documents']);
  }

  updateForm() {
    // Update existing controls
    this.orders.controls.forEach((control, index) => {
      if (this.uploadFiles[index]) {
        control.patchValue({
          file_name: this.uploadFiles[index].name,
          // Preserve other values
        });
      }
    });

    // Add new controls for any additional files
    const existingCount = this.orders.length;
    const newFiles = this.uploadFiles.slice(existingCount);

    newFiles.forEach((_, index) => {
      const actualIndex = existingCount + index;
      const orderGroup = this.createOrderGroup(actualIndex);
      this.orders.push(orderGroup);
    });
  }

  createOrderGroup(index: number): FormGroup {
    console.log('Creating form group for index:', index);

    const group = this.formBuilder.group({
      account_id: [null, Validators.required],
      branch_id: [null, Validators.required],
      referance_id: ['', [Validators.maxLength(80), Validators.required, this.referenceIdValidator()]],
      file_name: [this.uploadFiles[index]?.name || ''],
      document: [''],
    });

    // Generate reference ID
    if (!this.enableRefIdField) {
      this.generateReferenceId(group, index);
    }
    return group;
  }
  onReferencePaste(event: ClipboardEvent): void {
    if (!this.enableRefIdField) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') || '';
    const sanitized = clipboardData.replace(/[^a-zA-Z0-9_-]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const currentValue = input.value;
    const newValue = currentValue.slice(0, start) + sanitized + currentValue.slice(end);
    this.orders.get('referance_id')?.setValue(newValue);
  }
  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
    event.preventDefault();
    event.returnValue = false;
  }

  generateReferenceId(orderGroup: FormGroup, index: number) {
    this.catUploadService.getOrValidateReferenceId().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          orderGroup.patchValue(
            {
              referance_id: `${res.content.reference_id}`,
            },
            { emitEvent: false }
          );
          this.cdr.detectChanges();
        }
      },
      error: (err) => {
        console.error('Error generating reference ID:', err);
        this.messageService.add({
          severity: 'error',
          detail: err.error?.message || 'Failed to generate reference ID',
        });
      },
    });
  }
  handleBranchSelection(event: any, index: number) {
    const branch_id = event.value; // Get selected account ID
    this.orders.at(index).patchValue({ branch_id });
  }
  changeState(data: any) {
    this.selectedBranch = this.storageService.getBranch() || null;
  }

  onChange(event) {
    //this.router.navigate([event.value.url]);
    // window.location = event.value.url;
    fetch(event.value.url)
      .then((response) => response.arrayBuffer())
      .then((data) => {
        const workbook = read(data, { type: 'array' });
        const worksheet = workbook.Sheets['Sheet1']; // Replace 'Sheet Name' with the name of the existing sheet

        // Get the existing data from the sheet
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

        const newData = ['New Field 1', 'New Field 2', 'New Field 3'];
        this.headerData = jsonData[0];
        const fields = this.headerData.concat(newData);
        const workbook1 = XLSX.utils.book_new();
        // Create a new worksheet
        const worksheet1 = XLSX.utils.json_to_sheet([]);

        // Append new fields to the worksheet1
        XLSX.utils.sheet_add_aoa(worksheet1, [fields], { origin: -1 });

        // Add the worksheet1 to the workbook1
        XLSX.utils.book_append_sheet(workbook1, worksheet1, 'Sheet 1'); // Replace 'Sheet Name' with your desired sheet name

        const excelBuffer = XLSX.write(workbook1, {
          bookType: 'xlsx',
          type: 'array',
        });

        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Save the file using FileSaver.js
        FileSaver.saveAs(blob, 'BulkUploadFileFormat.xlsx');
      });
  }

  getVakue(event) {}

  downloadSample(value: string) {
    if (value === 'Cat-Upload') {
    if (this.currentStampType === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR) {
      this.fileUrl = 'assets/Sample_Files_Bulk_Upload/bulk_estamp_&_esign_esbtr.xlsx';
      this.fileName = 'bulk_estamp_&_esign_esbtr.xlsx';
    } else {
      this.fileUrl = 'assets/Sample_Files_Bulk_Upload/bulk_estamp_&_esign.xlsx';
      this.fileName = 'bulk_estamp_&_esign.xlsx';
    }
  }
    else if (value === 'E-Stamp' || value === 'E-Stamps') {
    // Check the value received from the other component via service
    if (this.currentStampType === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR) {
      this.fileUrl = 'assets/Sample_Files_Bulk_Upload/bulk_estamp_esbtr.xlsx';
      this.fileName = 'bulk_estamp_esbtr.xlsx';
    } else {
      this.fileUrl = 'assets/Sample_Files_Bulk_Upload/bulk_estamp.xlsx';
      this.fileName = 'bulk_estamp.xlsx';
    }
  } 
 else if (value === 'E-Sign') {
      this.fileUrl = 'assets/Sample_Files_Bulk_Upload/bulk_esign.xlsx';
      this.fileName = 'bulk_esign.xlsx';
    }
    this.downExcelSample(this.fileUrl, this.fileName);
  }

  downExcelSample(fileUrl: any, fileName: any) {
    this.http
      .get(fileUrl, { responseType: 'blob' })
      .subscribe((response: Blob) => {
        // Payment Link & cc_emails bulk upload: inject 4 new optional columns into every template on the fly
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const wb = XLSX.read(e.target.result, { type: 'binary' });
          const wsName = wb.SheetNames[0];
          const ws = wb.Sheets[wsName];
          const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });
          if (rows.length > 0) {
            const headers: string[] = rows[0] as string[];
            const newCols = ['payee_name', 'payee_email', 'payee_contact', 'cc_emails'];
            newCols.forEach(col => { if (!headers.includes(col)) headers.push(col); });
            rows[0] = headers;
            const updatedWs = XLSX.utils.aoa_to_sheet(rows);
            wb.Sheets[wsName] = updatedWs;
          }
          const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = fileName;
          downloadLink.click();
        };
        reader.readAsBinaryString(response);
      });
  }
  //-------------------Import & export Data from parent to child and vice-versa ----------------------------//

  onUploadDocsChange(data: any): void {
    this.uploadDocumentsData = data;
    if (this.uploadDocumentsData.option === 'In-complete') {
    } else {
      this.goToCatExecutionScreen('confirmation');
    }
  }

  onOrderConfirmationChange(data: any): void {
    this.orderConfirmationData = data;
    //this.orderDetails.getPlacedOrderDetails()
  }

  //-------------------------------------------------------------------------------------------------//

  //-------- to Display the required component depending on the click of the stepper------------//

  goToCatExecutionScreen(value: string): void {
    this.showUploadDocuments = value === 'uploadDocs';
    this.showEstampDetails = value === 'estamp';
    this.showEsignDetails = value === 'esign';
    this.showConfirmation = value === 'confirmation';
    this.setActiveTab(value);
  }

  //------------Change the color of the stepper on completion ------------------------------//

  setActiveTab(value: string) {
    // if (value == 'editTemplate')
    //   this.active_product = true;
    // this.active_eStamp = value !== 'editTemplate' && value !== 'estamp';
    // this.active_eSign = value !== 'editTemplate' && value !== 'estamp' && value !== 'esign';
    // this.active_confirm = value === 'confirmation';

    if (value === 'uploadDocs') {
      this.active_product = false;
      this.active_eStamp = false;
      this.active_eSign = false;
      this.active_confirm = false;
    } else {
      this.active_product = true;
      this.active_eStamp = value !== 'estamp';
      this.active_eSign = value !== 'estamp' && value !== 'esign';
      this.active_confirm = value === 'confirmation';
    }
  }

  gotoDashboard() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  back() {
    this.router.navigate(['doqfy/dashboard']);
  }
  onBranchChange() {
    this.storageService.setBranch(this.selectedBranch);
  }

  goBack() {
    if (this._location.path() == '/doqfy/bulk-upload/form/cat-upload') {
      this.router.navigate(['doqfy/cat-execution/form']);
    } else if (this._location.path() == '/doqfy/bulk-upload/form/e-stamp') {
      this.router.navigate(['doqfy/e-stamp/form']);
    } else if (this._location.path() == '/doqfy/bulk-upload/form/e-sign') {
      this.router.navigate(['doqfy/e-sign/form']);
    } else if (this._location.path() == '/doqfy/bulk-upload/form/cat-import') {
      this.gotoDashboard();
    }
  }

  getArticleCode(content) {
    this.modalService
      .open(content, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  closeModel() {
    this.modalService.dismissAll();
  }
  triggerBulkFileInput(input: HTMLInputElement) {
    if (this.uploadFiles.length >= 10) {
      this.messageService.add({
        severity: 'error',
        summary: 'Maximum Limit Reached',
        detail: 'You can only upload a maximum of 10 files at a time.',
      });
      return;
    }
    input.click();
  }

  openUploadDocPopup() {
    if (this.uploadFiles.length >= 10) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'You can only upload a maximum of 10 PDFs.',
      });
      return;
    }

    // Reset state
    this.fileName = '';
    this.tempFiles = [];
    this.chooseFile = false;
    this.showFileName = false;
    const fileInput = document.getElementById(
      'upload_file'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Clear file input
    }

    // Programmatically open the modal using Bootstrap JS
    const modalElement = document.getElementById('uploadDocModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }

    this.fileName = 'Selected File';
    //this.cancelUpload();
  }

  cancelUpload() {
    // Reset state
    this.fileSizeError = false;
    this.fileName = '';
    this.tempFiles = [];
    this.showFileName = false;
    this.chooseFile = false;
    const fileInput = document.getElementById(
      'upload_file'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Clear file input
    }
    // Close modal
    this.closeUploadPopupBtn.nativeElement.click();
  }

  clearFile() {
    this.uploadFiles = []; // Reset files only if necessary
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    if (inputElement) {
      inputElement.value = null;
      this.fileSizeError = false;
    }
  }
  removeFileName(index: number) {
    this.uploadFiles.splice(index, 1);

    if (this.branchData && this.branchData.length > index) {
      this.branchData.splice(index, 1);
    }

    // Remove corresponding form group from the FormArray
    const formArray = this.bulkOrderDetailsForm.get('orders') as FormArray;
    formArray.removeAt(index);

    // Update UI state
    if (this.uploadFiles.length === 0) {
      this.showFileName = false;
    }
  }
  async onFileChange(event: any) {
    const files: FileList = event.target.files;
    const fileArray: File[] = Array.from(files) as File[];
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit
    this.resetErrors();

    // 1. FILTER: Only PDF files
    const pdfFiles = fileArray.filter((file) => {
      return (
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
      );
    });

    // Check if any non-PDF files were selected
    const nonPdfFiles = fileArray.filter((file) => {
      return (
        file.type !== 'application/pdf' &&
        !file.name.toLowerCase().endsWith('.pdf')
      );
    });

    if (nonPdfFiles.length > 0) {
      this.showError(
        'Invalid File Type',
        `Only PDF files are allowed. Rejected: ${nonPdfFiles
          .map((f) => f.name)
          .join(', ')}`,
        'warn'
      );
      return;
    }

    // 2. SIZE VALIDATION
    const oversizedFiles = pdfFiles.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      this.fileSizeError = true;
      this.showError(
        'File Too Large',
        `Files exceeding 15MB limit: ${oversizedFiles
          .map((f) => f.name)
          .join(', ')}. Please upload a smaller PDF so it can be processed within the gateway's size limits.`,
        'error'
      );
      return;
    }

    // 3. Check if adding these files exceeds the limit
    if (this.uploadFiles.length + pdfFiles.length > 10) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'You can only upload a maximum of 10 PDFs.',
      });
      const fileInput = document.getElementById(
        'upload_file'
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      return;
    }

    // 4. SECURITY VALIDATION
    try {
      const securityResults = await Promise.all(
        pdfFiles.map((file) => this.pdfSecurityService.validateAndSanitizePDF(file, 
        { skipESignatureCheck: true }))
      );

      // Separate e-signed files from other malicious files
      const eSignedFiles = pdfFiles.filter(
        (_, index) => securityResults[index].isESigned === true
      );

      const maliciousFiles = pdfFiles.filter(
        (_, index) =>
          !securityResults[index].isValid && !securityResults[index].isESigned
      );

      // Handle e-signed PDFs with special message
      if (eSignedFiles.length > 0) {
        this.securityError = true;
        this.showError(
          'Electronic Signature Detected',
          `This file contains electronic signature: ${eSignedFiles
            .map((f) => f.name)
            .join(', ')}`,
          'warn'
        );
        return;
      }

      // Handle other security threats
      if (maliciousFiles.length > 0) {
        this.securityError = true;
        const errorDetails = maliciousFiles
          .map((file, idx) => {
            const fileIndex = pdfFiles.indexOf(file);
            return `• ${file.name}: ${securityResults[fileIndex].reason}`;
          })
          .join('\n');

        this.showError(
          'Security Threat Detected',
          `The following PDF(s) failed security validation:\n${errorDetails}`,
          'error'
        );
        return;
      }
    } catch (error) {
      console.error('Security validation error:', error);
      this.securityError = true;
      this.showError(
        'Validation Failed',
        'Unable to validate PDF security. Please try again or contact support.',
        'error'
      );
      return;
    }

    // 6. ALL VALIDATIONS PASSED - Process files
    await this.processValidFiles(pdfFiles);
  }

  private async processValidFiles(fileArray: File[]) {
    try {
      // Generate secure preview for first file
      if (fileArray.length > 0) {
        await this.generateSecurePreview(fileArray[0]);
      }

      // Store files temporarily
      this.tempFiles = fileArray;
      this.fileName = fileArray.map((file) => file.name).join(', ');
      this.fileSizeError = false;
      this.showFileName = true;
      this.chooseFile = false;

      // Success message
      const count = fileArray.length;
      this.messageService.add({
        severity: 'success',
        summary: count === 1 ? 'File Ready' : 'Files Ready',
        detail:
          count === 1
            ? `${count} file validated and ready to upload`
            : `${count} files validated and ready to upload`,
        life: 3000,
      });
    } catch (error) {
      console.error('File processing error:', error);
      this.showError(
        'Processing Failed',
        'Error processing files. Please try again.',
        'error'
      );
    }
  }

  private async processDroppedFiles(pdfFiles: File[]) {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    // Size validation
    const oversizedFiles = pdfFiles.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      this.fileSizeError = true;
      this.showError(
        'File Too Large',
        `Files exceeding 15MB limit: ${oversizedFiles
          .map((f) => f.name)
          .join(', ')}. Please upload a smaller PDF so it can be processed within the gateway's size limits.`,
        'error'
      );
      return;
    }

    // Security validation using SHARED SERVICE
    try {
      const securityResults = await Promise.all(
        pdfFiles.map((file) => this.pdfSecurityService.validateAndSanitizePDF(file, 
        { skipESignatureCheck: true }))
      );

      const eSignedFiles = pdfFiles.filter(
        (_, index) => securityResults[index].isESigned === true
      );

      const maliciousFiles = pdfFiles.filter(
        (_, index) =>
          !securityResults[index].isValid && !securityResults[index].isESigned
      );

      if (eSignedFiles.length > 0) {
        this.securityError = true;
        this.showError(
          'Electronic Signature Detected',
          `This file contains electronic signature: ${eSignedFiles
            .map((f) => f.name)
            .join(', ')}`,
          'warn'
        );
        return;
      }

      if (maliciousFiles.length > 0) {
        this.securityError = true;
        const errorDetails = maliciousFiles
          .map((file) => {
            const fileIndex = pdfFiles.indexOf(file);
            return `• ${file.name}: ${securityResults[fileIndex].reason}`;
          })
          .join('\n');

        this.showError(
          'Security Threat Detected',
          `The following PDF(s) failed security validation:\n${errorDetails}`,
          'error'
        );
        return;
      }
    } catch (error) {
      console.error('Security validation error:', error);
      this.securityError = true;
      this.showError(
        'Validation Failed',
        'Unable to validate PDF security. Please try again.',
        'error'
      );
      return;
    }

    // All validations passed
    this.tempFiles = pdfFiles;
    this.fileName = this.tempFiles.map((file) => file.name).join(', ');
    this.showFileName = true;
    this.chooseFile = false;

    // Generate secure preview using SHARED SERVICE
    if (pdfFiles.length > 0) {
      this.safePreviewContent = await this.pdfSecurityService.generateSecurePreview(pdfFiles[0]);
    }

    // Auto-upload after validation
    this.uploadSelFile();
  }

  async validatePdf() {
    try {
      for (let i = 0; i < this.uploadFiles.length; i++) {
        const file = this.uploadFiles[i];
        const fileExtension = file.name.split('.').pop()?.toLowerCase();

        if (fileExtension === 'pdf') {
          // Read PDF and convert to Base64
          const base64Data = await this.convertFileToBase64(file);

          // Validate Base64 size using service
          if (
            !this.pdfValidationService.validateBase64String(
              base64Data,
              file.name
            )
          ) {
            // Remove the problematic file
            this.removeFileName(i);
            return false;
          }

          // Get the form array
          const ordersArray = this.bulkOrderDetailsForm.get(
            'orders'
          ) as FormArray;

          // Update the corresponding form control
          if (ordersArray && ordersArray.controls[i]) {
            ordersArray.controls[i].patchValue({
              document: base64Data,
              file_name: file.name,
            });
          }
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Please upload a PDF file',
          });
          return false;
        }
      }
      return true;
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Error processing PDF file',
      });
      return false;
    }
  }

  /**
   * Convert File to Base64
   */
  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }
  async uploadSelFile() {
    // Check if there are files
    if (
      (!this.tempFiles || this.tempFiles.length === 0) &&
      this.uploadFiles.length === 0
    ) {
      this.chooseFile = true;
      this.showError('No Files', 'Please select files to upload', 'warn');
      return;
    }

    // Final security check before upload using SHARED SERVICE
    try {
      const filesToValidate =
        this.tempFiles && this.tempFiles.length > 0
          ? this.tempFiles
          : this.uploadFiles;

      const finalValidation = await Promise.all(
      filesToValidate.map((file) => 
        this.pdfSecurityService.validateAndSanitizePDF(file, 
      { skipESignatureCheck: true })
      )
    );

    // Check for e-signed files
    const eSignedFiles = filesToValidate.filter(
      (_, index) => finalValidation[index].isESigned === true
    );

    // Check for invalid files (excluding e-signed ones)
    const invalidFiles = filesToValidate.filter(
      (_, index) =>
        !finalValidation[index].isValid && !finalValidation[index].isESigned
    );

    if (eSignedFiles.length > 0) {
        this.showError(
        'Electronic Signature Detected',
        `File contains electronic signature: ${eSignedFiles
          .map((f) => f.name)
          .join(', ')}`,
        'warn'
      );
      return;
    }

    if (invalidFiles.length > 0) {
      const errorDetails = invalidFiles
        .map((file) => {
          const fileIndex = filesToValidate.indexOf(file);
          return `• ${file.name}: ${finalValidation[fileIndex].reason}`;
        })
        .join('\n');

      this.showError(
        'Security Threat Detected',
        `The following PDF(s) failed security validation:\n${errorDetails}`,
          'error'
        );
        return;
      }

      // All validations passed - proceed with upload
      if (this.tempFiles && this.tempFiles.length > 0) {
        this.uploadFiles.push(...this.tempFiles);
      }

      this.updateForm();

      // Reset state
      this.fileName = '';
      this.tempFiles = [];
      this.showFileName = false;
      this.chooseFile = false;

      const fileInput = document.getElementById(
        'upload_file'
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }

      this.closeUploadPopupBtn.nativeElement.click();
    } catch (error) {
      console.error('Upload error:', error);
      this.showError(
        'Upload Failed',
        'An error occurred during upload. Please try again.',
        'error'
      );
    }
  }
  onSelectedAccount(event: any, index: number): void {
    const account_id = event.value; // Get selected account ID
    this.orders.at(index).patchValue({ account_id });
    this.getBranchList(account_id, index);
  }

  getUserDetails(id) {
    this.userManagementService.getUsersDetailsById(id).subscribe((res: any) => {
      const userData = res['content'][0];
      this.userBranches = userData.branches;
      this.cdr.detectChanges();
    });
  }

  getBranchList(account_id: string, index: number) {
    this.branchManagementService
      .getBranchPerUser(account_id)
      .subscribe((res) => {
        this.branchData[index] = res['content'];
        this.branchData[index] = this.branchData[index].filter((branch) =>
          this.userBranches.includes(branch.id)
        );
        this.cdr.detectChanges();
      });
  }

  setLoaderState(
    index: number,
    isLoading: boolean,
    isCompleted: boolean = false
  ) {
    const loaderElement = document.getElementById(`loader-${index}`);
    const checkmarkElement = document.getElementById(`checkmark-${index}`);

    if (loaderElement) {
      loaderElement.style.display = isLoading ? 'inline-block' : 'none';
    }

    if (checkmarkElement) {
      checkmarkElement.style.display = isCompleted ? 'inline-block' : 'none';
    }
  }

  async placeOrder() {
    this.submitted = true;
    await this.validatePdf();
    if (this.bulkOrderDetailsForm.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill all the required fields',
      });
      return;
    }

    const formValues = (
      this.bulkOrderDetailsForm.get('orders') as FormArray
    ).controls.map((control) => ({
      document: control.get('document')?.value,
      file_name: control.get('file_name')?.value,
      account_id: control.get('account_id')?.value,
      branch_id: control.get('branch_id')?.value,
      referance_id: control.get('referance_id')?.value,
    }));

    // Hide all loaders and checkmarks initially
    formValues.forEach((_, index) => {
      this.setLoaderState(index, false, false);
    });

    const orderIds: (string | number)[] = [];
    let lastOrderId: string | number = '';

    // Process orders sequentially
    from(formValues)
      .pipe(
        concatMap((formValue, index) => {
          const payload = {
            is_bulk: false,
            order_details: [formValue],
          };

          // Show loader for current index
          this.setLoaderState(index, true);

          return this.catUploadService.catImportPlaceOrder(payload).pipe(
            tap((res: any) => {
              // Store each order ID
              orderIds.push(res.content.order_id);
              lastOrderId = res.content.order_id;
              // Show checkmark for completed order
              this.setLoaderState(index, false, true);
            }),
            catchError((error) => {
              this.setLoaderState(index, false, false);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `Failed to place order ${index + 1}: ${error.message}`,
              });
              return EMPTY;
            })
          );
        }),
        reduce((count) => count + 1, 0),
        finalize(() => {
          if (orderIds.length > 0) {
            // Store order IDs in the service
            this.catUploadService.setOrderIds(orderIds);

            setTimeout(() => {
              this.router.navigate([
                'doqfy/cat-import/order-confirmation',
                lastOrderId,
              ]);
            }, 1000);
          }
        })
      )
      .subscribe();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  async onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileArray: File[] = Array.from(files);

      // Filter only PDF files
      const pdfFiles = fileArray.filter((file) => {
        return (
          file.type === 'application/pdf' ||
          file.name.toLowerCase().endsWith('.pdf')
        );
      });

      // Check if any non-PDF files were dropped
      const nonPdfFiles = fileArray.filter((file) => {
        return (
          file.type !== 'application/pdf' &&
          !file.name.toLowerCase().endsWith('.pdf')
        );
      });

      if (nonPdfFiles.length > 0) {
        this.messageService.add({
          severity: 'error',
          detail: `Only PDF files are allowed. Rejected files: ${nonPdfFiles
            .map((f) => f.name)
            .join(', ')}`,
        });
      }

      // Check if adding these files exceeds the limit
      if (this.uploadFiles.length + pdfFiles.length > 10) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'You can only upload a maximum of 10 PDFs.',
        });
        return;
      }

      // Process only PDF files if any
      if (pdfFiles.length > 0) {
        await this.processDroppedFiles(pdfFiles);
      }
    }
  }

  removeTempFile(index: number) {
    this.tempFiles.splice(index, 1);
    this.fileName = this.tempFiles.map((file) => file.name).join(', ');
    if (this.tempFiles.length === 0) {
      this.showFileName = false;
    }
  }


  private async processFiles(base64: string | null, fileArray: File[]) {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    // Validation Step 1: File size check
    const oversizedFiles = fileArray.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      this.fileSizeError = true;
      const oversizedFileNames = oversizedFiles
        .map((file) => file.name)
        .join(', ');
      this.messageService.add({
        severity: 'error',
        summary: 'File Size Exceeded',
        detail: `Files exceeding 15MB limit: ${oversizedFileNames}. Please upload a smaller PDF so it can be processed within the gateway's size limits.`,
        life: 5000,
      });
      return;
    }

    // Validation Step 2: Filter only PDF files
    const pdfFiles = fileArray.filter(
      (file) =>
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
    );

    const nonPdfFiles = fileArray.filter(
      (file) =>
        file.type !== 'application/pdf' &&
        !file.name.toLowerCase().endsWith('.pdf')
    );

    if (nonPdfFiles.length > 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid File Type',
        detail: `Only PDF files are allowed. Rejected: ${nonPdfFiles
          .map((f) => f.name)
          .join(', ')}`,
        life: 5000,
      });
    }

    // Validation Step 3: Security validation for PDFs
    if (pdfFiles.length > 0) {
      try {
        // Show loading indicator
        this.messageService.add({
          severity: 'info',
          summary: 'Validating Files',
          detail: 'Checking PDF files for security issues...',
          life: 2000,
        });

        // Check each PDF for malicious content
        const validationResults = await Promise.all(
          pdfFiles.map((file) => this.pdfSecurityService.validateAndSanitizePDF(file, 
          { skipESignatureCheck: true }))
        );

        const invalidFiles: Array<{ file: File; reason: string }> = [];
        pdfFiles.forEach((file, index) => {
          if (!validationResults[index].isValid) {
            invalidFiles.push({
              file: file,
              reason: validationResults[index].reason || 'Unknown error',
            });
          }
        });

        if (invalidFiles.length > 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Security Validation Failed',
            detail: invalidFiles
              .map((item) => `${item.file.name}: ${item.reason}`)
              .join('\n'),
            life: 7000,
          });
          return;
        }

        // All validations passed
        this.fileSizeError = false;
        this.uploadFiles.push(...pdfFiles);
        this.showFileName = true;
        this.chooseFile = false;
        this.fileName = this.uploadFiles.map((file) => file.name).join(', ');
        this.storageService.setfiletype('pdf');

        this.messageService.add({
          severity: 'success',
          summary: 'Files Validated',
          detail: `${pdfFiles.length} file(s) ready for upload`,
          life: 3000,
        });
      } catch (error) {
        console.error('Error validating PDFs:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: 'Error processing PDF files. Please try again.',
          life: 5000,
        });
        return;
      }
    } else if (nonPdfFiles.length === 0) {
      // No valid files at all
      this.messageService.add({
        severity: 'warn',
        summary: 'No Valid Files',
        detail: 'Please select at least one PDF file',
        life: 3000,
      });
    }
  }

  sanitizeHtml(dirty: string): string {
    return DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: ['span', 'p', 'br'],
      ALLOWED_ATTR: [],
      FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'svg'],
    });
  }

  sanitizeTextOnly(dirty: string): string {
    return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] });
  }

  private async generateSecurePreview(file: File) {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      const textContent = new TextDecoder('latin1').decode(uint8Array);

      // Extract and sanitize first 1000 characters
      const previewText = textContent.substring(0, 1000);

      // Use DOMPurify to strip ALL HTML/script tags
      this.safePreviewContent = this.sanitizeTextOnly(previewText);

      // If preview is empty or too short, show generic message
      if (!this.safePreviewContent || this.safePreviewContent.length < 10) {
        this.safePreviewContent =
          'PDF uploaded securely. Preview not available.';
      }
    } catch (error) {
      console.error('Preview generation error:', error);
      this.safePreviewContent =
        'PDF uploaded securely. Use download to view full content.';
    }
  }

  private resetErrors() {
    this.fileSizeError = false;
    this.securityError = false;
    this.signatureError = false;
    this.chooseFile = false;
  }

  private showError(summary: string, detail: string, severity: string) {
    this.messageService.add({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  }

  // === Cloud upload Methods ===

  // --- Google Drive Methods ---

  openGoogleDrive() {
    this.showGoogleDriveModal = true;
  }

  onGoogleDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    if (event.file.size === 0) {
      // console.error('Received empty file:', event.fileName);
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    if (this.uploadFiles.length === 0) {
      this.fileName = event.fileName;
      this.base64Data = event.base64;
    } else {
      this.fileName = this.fileName + ', ' + event.fileName;
    }

    this.processFiles(event.base64, [event.file]);
    // console.log('Google Drive file selected:', event.fileName);
  }

  onGoogleDriveModalClosed() {
    this.showGoogleDriveModal = false;
  }
  // --- End Google Drive Methods ---

  // --- Link Upload Methods ---
  openLink() {
    this.closeUploadPopupBtn.nativeElement.click();
    this.showLinkModal = true;
  }

  onLinkFileSelected(fileData: any) {
    // Add the file from link to uploadFiles directly (similar to uploadSelFile logic)
    this.uploadFiles.push(fileData.file);

    // Update the form with the new files
    this.updateForm();

    // Reset any temporary state if needed
    this.fileName = '';
    this.showFileName = false;
    this.chooseFile = false;

    // Clear file input if exists
    const fileInput = document.getElementById(
      'upload_file'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onLinkModalClosed() {
    this.showLinkModal = false;
    console.log('Link modal closed');
  }

  // --- End Link Upload Methods ---

  // --- Dropbox Methods ---
  openDropbox() {
    // this.closeUploadPopupBtn.nativeElement.click();
   if (!this.dropboxEnabled) return;
    this.showDropboxModal = true;
  }

  onDropboxFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from Dropbox`,
    });

    console.log('Dropbox file selected:', event.fileName);
  }

  onOneDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    // Check if file is already selected
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    // Check if file is empty
    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from Dropbox`,
    });

    console.log('Dropbox file selected:', event.fileName);
  }

  onDropboxModalClosed() {
    this.showDropboxModal = false;
  }

  // --- End Dropbox Methods ---

  // --- OneDrive Methods ---
  openOneDrive() {
    this.showOneDriveModal = true;
    console.log('Opening OneDrive modal...');
  }
  onOneDriveModalClosed() {
    this.showOneDriveModal = false;
    console.log('OneDrive modal closed');
  }

  getRefIdConsent() {
    let refIdConsent = this.storageService.getRefIdConsent() || null;
    if (refIdConsent === true) this.enableRefIdField = true;
    else {
      this.enableRefIdField = false;
    }
  }
}